import React from "react";
import PropTypes from "prop-types";
import { Popup } from "semantic-ui-react";

const Tooltip = ({ icon, message, ...rest }) => (
  <Popup {...rest} trigger={<i className={icon} />}>
    <span dangerouslySetInnerHTML={{ __html: message }} />
  </Popup>
);

Tooltip.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.string.isRequired,
};

Tooltip.defaultProps = {
  icon: "question circular icon",
};

export default Tooltip;

// usage example
/*
<span
  id="a-unique-id"
  class="ui tooltip"
  data-wide="very"
  data-size="small"
  data-message="This is the text that goes in the tooltip popup"
  data-icon="question circular inverted icon">
</span>
*/
